export interface PartnershipConfig {
    /** URL path segment (e.g., 'ditsch' for /ditsch) */
    slug: string
    /** Partnership display name */
    name: string
    /** Logo configuration. Omit to hide the partnership × NeoTaste logo row. */
    logo?: {
        src: string
        alt: string
        width: number
        height: number
    }
    /** Number of free months offered */
    amountOfMonths: number
    /** Translation key prefix for partnership-specific copy (optional, falls back to standard copy) */
    translationPrefix?: string
    /** Show warning alert (like Urban Sports Club) */
    showAlert?: boolean
    /** ISO timestamp; when set, a countdown is shown instead of the partnership logo row. */
    countdownEndsAt?: string
}

export const PARTNERSHIP_CONFIGS: Record<string, PartnershipConfig> = {
    urbansportsclub: {
        slug: 'urbansportsclub',
        name: 'Urban Sports Club',
        logo: {
            src: '/_images/navigation/urban-sports-club-logo.png',
            alt: 'Urban Sports Club Logo',
            width: 50,
            height: 115,
        },
        amountOfMonths: 3,
        translationPrefix: 'baseLayout.code.urbansportsclub',
        showAlert: true,
    },
    ditsch: {
        slug: 'ditsch',
        name: 'Ditsch',
        logo: {
            src: '/_images/navigation/ditsch-logo.png',
            alt: 'Ditsch Logo',
            width: 100,
            height: 115,
        },
        amountOfMonths: 2,
        showAlert: false,
    },
    zenjob: {
        slug: 'zenjob',
        name: 'Zenjob',
        logo: {
            src: '/_images/navigation/zenjob-logo.png',
            alt: 'Zenjob Logo',
            width: 140,
            height: 42,
        },
        amountOfMonths: 2,
        showAlert: false,
    },
    uber: {
        slug: 'uber',
        name: 'Uber',
        logo: {
            src: '/_images/navigation/uber-logo.svg',
            alt: 'Uber Logo',
            width: 100,
            height: 35,
        },
        amountOfMonths: 3,
        showAlert: false,
    },
    lieferando: {
        slug: 'lieferando',
        name: 'Lieferando',
        amountOfMonths: 3,
        translationPrefix: 'baseLayout.code.lieferando',
        // Tuesday 2026-06-30 23:59 Europe/Berlin (CEST, UTC+2)
        countdownEndsAt: '2026-06-30T23:59:00+02:00',
    },
    flink: {
        slug: 'flink',
        name: 'Flink Prime',
        logo: {
            src: '/_images/navigation/flink-prime-logo.png',
            alt: 'Flink Prime Logo',
            width: 150,
            height: 30,
        },
        amountOfMonths: 3,
    },
}

export function getPartnershipConfig(slug: string): PartnershipConfig | undefined {
    return PARTNERSHIP_CONFIGS[slug]
}
